import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, ActivityIndicator, Picker, Platform } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, article, button, articleItem, FontFamily, articleLists, FontWeight, Colors } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import ArticleItemHorizontal from '../article-item-layout-horizontal';
import ScrollContainerView from '../scroll-container-view';
import { helpers } from '../../utils/helpers';
import PageBreak from '../page-break';
import ArticleItem from '../article-item';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import Cookies from "universal-cookie";
import { Mixpanel } from '../../utils/mixpanel';
import AuthenticationWrapper from '../authentication-wrapper';

const viewMore = getImagePath('icons/view-more.png');
const priceIcon = getImagePath('icons/coin.png');
const cookies = new Cookies();
const windowWidth = Dimensions.get('window').width;

export class HomePremiumStory extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const {isAuthenticated, fetchToken} = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
        }
    }

    componentDidMount = () => {
    }

    viewAllStories = () => {
        const { viewAllStories } = this.props;
        viewAllStories()
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }
    
    viewCategory = (slug) => {
        const { viewCategory } = this.props;
        viewCategory(slug)
    }

    handleClick = (title, data, index) => {
        try {
            if (this.props.trackStoryClick) {
                this.props.trackStoryClick(title, data, index);
            }
        }
        catch (error) {
            console.log("check mix panel track error ==>", error);
        }
    }

    trackCateoryClick = (item) => {
        // try {
        //     Mixpanel.track('category', { category_slug: item.category.slug, source_section_type: 'home_premium_stories', section_value: { title: item.name, slug: item.slug } });
        // }
        // catch (error) {
        //     console.log("mix panel error =>", error);
        // }
    }

    render() {
        const { data, credits, darkMode } = this.props;
        let btnClick, btnClickCategory;
        let webView = helpers.isWeb();
        if (helpers.isWeb()) {
            btnClick = {
                to: "/all-stories"
            };

        } else {
            btnClick = {
                onPress: () => this.viewAllStories()
            }
        }
        return (

            <View style={[Padding.ph_2, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, helpers.isDesktop() && { marginTop: 120 }, !helpers.isDesktop() && Margin.mt_5, darkMode && {backgroundColor: Colors.darkBlackColorBg}]}>
                <View style={[article.headerWrapper, !helpers.isDesktop() && { position: 'absolute' }, !helpers.isDesktop() && { left: 0 }, !helpers.isDesktop() && { right: 0 }, !helpers.isDesktop() && { top: -15 }]}>
                    <View style={[Flex.alignCenter, Margin.mb_2, !helpers.isDesktop() && Margin.mb_4]}>
                        <View style={[Padding.ph_2, Helpers.titleBgWrap, darkMode && { backgroundColor: Colors.darkBlackColorBg}]}>
                            <View style={[Helpers.borderBottom, darkMode && {borderBottomColor: 'rgba(255,255,255,0.6)'}]}>
                                <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontSize: 18 }, { fontFamily: FontFamily.abrilFatface, color: '#000' }, { fontSize: helpers.isDesktop() ? 34 : 20 },darkMode && {color: 'rgba(255,255,255,0.87)'}]}>Premium stories</Text>
                            </View>
                        </View>
                        <View style={[Helpers.titleLine, darkMode && {backgroundColor: 'rgba(255,255,255,0.6)'}]}></View>
                    </View>
                </View>
                <View style={[!helpers.isDesktop() && Padding.pt_4, !helpers.isDesktop() && { paddingBottom: 15 }]}>
                    <Text style={[{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 14, lineHeight: helpers.isDesktop() ? 27 : 22, color: '#292929', textAlign: 'center', marginBottom: helpers.isDesktop() ? 24 : 0, letterSpacing: 0.3 }, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>Stories that can be unlocked by using Privilege credits or by subscribing.</Text>
                </View>
                <View style={[Flex.row, Flex.alignCenter, Flex.justfiyCenter]}>
                    <CustomImage
                        source={priceIcon}
                        require={true}
                        style={{ width: helpers.isDesktop() ? 30 : 20, height: helpers.isDesktop() ? 30 : 20 }}
                        webStyle={{ width: helpers.isDesktop() ? 30 : 20, height: helpers.isDesktop() ? 30 : 20 }}
                        altText={'Premium stories'}
                    />
                    <Text style={[Padding.pl_1, { fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 20 : 16, lineHeight: 34, color: '#292929' },darkMode && {color: 'rgba(255,255,255,0.87)'}]}>Privilege Credit Balance: </Text>
                    <Text style={[{ color: '#f02121', fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 20 : 16, lineHeight: 34 }, credits && credits.privileged_credits && credits.privileged_credits.available > 2 && { color: '#55C79A' }]}>{credits && credits.privileged_credits ? credits.privileged_credits.available : 0}</Text>
                </View>
                <View style={[helpers.isDesktop() && Margin.mt_7, helpers.isDesktop() && Margin.mb_4]}>
                    {helpers.isDesktop() ?
                        <View style={[Flex.row, Flex.justfiyCenter]}>
                            {data && data.map((item, index) => {
                                if (helpers.isWeb()) {
                                    btnClickCategory = {
                                        to: "/category/" + item.category.slug
                                    }
                                } else {
                                    btnClickCategory = {
                                        onPress: () => this.viewCategory(item.category.slug)
                                    }
                                }
                                return (
                                    <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop, { marginRight: 20 }, { width: helpers.isDesktop() ? '32.2%' : '100%' }, (index == 2) && {marginRight: 0}]}>
                                        <TouchableOpacityLink {...btnClickCategory} handleClick={() => this.trackCateoryClick(item)}>
                                            <View>
                                                <Text style={[articleLists.badge, { width: 150, marginBottom: helpers.isDesktop() ? 15 : 10, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff', letterSpacing: 1 },darkMode && {color: '#5263F4'}, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>{item.category.name}</Text>
                                            </View>
                                        </TouchableOpacityLink>
                                        <ArticleItemHorizontal viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} homepage={true} handleClick={(title) => { this.handleClick(title, item, index) }}  hideDate={true} darkMode={darkMode} />
                                    </View>
                                )
                            })}
                        </View>
                        :
                        <ScrollContainerView horizontal={true} showsHorizontalScrollIndicator={false}>
                            <View style={[Flex.row, Margin.mb_4, !process.browser && { overflow: 'hidden' }]}>
                                {data && data.map((item, index) => {
                                    if (helpers.isWeb()) {
                                        btnClickCategory = {
                                            to: "/category/" + item.category.slug
                                        }
                                    } else {
                                        btnClickCategory = {
                                            onPress: () => this.viewCategory(item.category.slug)
                                        }
                                    }
                                    return (
                                        <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop, !helpers.isDesktop() && { marginTop: 50 },!webView && {width: windowWidth -90}]}>
                                            <TouchableOpacityLink {...btnClickCategory} handleClick={() => this.trackCateoryClick(item)}>
                                                <View>
                                                    <Text style={[articleLists.badge, { width: 150, marginBottom: helpers.isDesktop() ? 15 : 10, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff', fontSize: 13, lineHeight: 16, letterSpacing: 0.5 },darkMode && {color: '#5263F4'},  !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>{item.category.name}</Text>
                                                </View>
                                            </TouchableOpacityLink>
                                            <ArticleItemHorizontal viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} homepage={true} handleClick={(title) => { this.handleClick(title, item, index) }}  hideDate={true} darkMode={darkMode} />
                                        </View>
                                    )
                                })}
                                <TouchableOpacityLink
                                    {...btnClick}
                                >
                                    <View style={[Flex.column, Flex.alignCenter, { width: 155, position: helpers.isWeb() ? 'absolute' : 'relative', top: 144, marginLeft: -15 }]}>
                                        <CustomImage
                                            source={viewMore}
                                            require={true}
                                            style={{ width: 36, height: 36, margin: 'auto' }}
                                            webStyle={{ width: 36, height: 36, margin: 'auto' }}
                                        />
                                        <Text style={[button.secondaryOutlineText, Margin.mr_0, { fontWeight: '500' }]}>View all stories</Text>
                                    </View>
                                </TouchableOpacityLink>
                            </View>
                        </ScrollContainerView>
                    }
                    {helpers.isDesktop() &&
                        <View style={[Flex.alignCenter, Margin.mt_4, { marginTop: helpers.isDesktop() ? 70 : 40 }, helpers.isDesktop() && { marginBottom: 30 }]}>
                            <TouchableOpacityLink
                                {...btnClick}
                            >
                                <View style={[Flex.row, Flex.alignCenter]}>
                                    <Text style={[button.secondaryOutline, helpers.isDesktop() && button.secondaryOutlineDesktop, Margin.mr_0, { fontWeight: FontWeight.light }]}>View all stories</Text>
                                </View>
                            </TouchableOpacityLink>
                        </View>
                    }
                </View>
            </View>
        );
    }
}

export default AuthenticationWrapper(HomePremiumStory);
